// 组织架构dlg组件

const orgStrucDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    chartData: {},
  },

  getters: {
    dlgShow: state => state.dlgShow,

    chartData: state => state.chartData
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_CHARTDATA: (state, val) => {
      state.chartData = val
    },
  },

  actions: {

  }
}

export default orgStrucDlg
